<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; letter-spacing:1px; font-size:18pt; padding-top:10px;">About the Author</h1>
<p style="text-align: center;"><img alt=" " src="media/file0.jpg" style="width:2.0625in;height:2.80208in"/></p><br/>
<p style="text-indent:0px;">Yvonne Webb has led an accomplished professional life as an academic, culinary dietitian, author, nutritionist/physiologist, researcher and consultant to government bodies and industry, and has been a national and international speaker. She has held leadership positions of various relevant bodies.</p>
<p>An Honours from Shimane University, Japan, and time spent at Uppsala University, Sweden, have been part of her active life.</p>
<p>She is a Slow Food disciple and gourmand and was at one time Leader of Slow Food Brisbane.</p>
<p>Concern with the obesity epidemic and the amount of myth, fake news and marketing surrounding this problem has led to this book.</p>
<p>Having previously established a very successful weight control clinic, she has decided to reveal her secrets based on established scientific knowledge.</p>
<p>Nowadays, Yvonne has retired to the suburbs, cultivates an edible garden and gives talks to community groups.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2fd264c0